import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation } from '@react-navigation/native'
import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import LoadingComponent from 'components/atoms/Loading'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import _ from 'lodash'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import Translate from 'utils/translate'
import { listArrow } from 'styles/list'
import { AppRoutes } from 'navigations/app-routes'
import FetchManagementCompany from 'utils/fetch/management/FetchManagementCompany'
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import { useSelector } from 'react-redux'
import { managementConstants } from 'services/redux/management/constants'
import { useShowHamburger } from 'utils/helper-device'
import ListItem from 'components/atoms/ListItem'

const ManagementCompaniesScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const showHamburger = useShowHamburger();
	
	const [ loading, setLoading ] = useState( true )
	const [ search, setSearch ] = useState( '' )
	
	const _managementCompanies = useSelector( state => {
		return state.management[managementConstants.COMPANIES];
	} )
	
	const fetchCompanies = () => {
		FetchManagementCompany.fetchAll({
			variables: {
				active: constantsGraphql.YES_NO,
			},
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: setLoading.bind( this, false ),
		});
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				subtitle={ i18n.t('management:pages.company.companies.subtitle', { count: item.department_count } ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openCompany }
			/>
		)
	}
	
	const openCompany = ( company ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_COMPANY_COMPANIES_VIEW, {
			companyGuid: company.guid
		} );
	}
	
	const createCompany = () => {
		openCompany( {} );
	}
	
	const searchChanged = ( value ) => {
		setSearch( value?.toLowerCase() ?? '' )
	}
	
	useEffect( () => {
		return fetchCompanies();
	}, [ isFocused ] )
	
	const filters = _.size( search ) > 2 ? [ { field: 'name', kind: 'contains', value: search } ] : null;
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.company.companies.input_search_company'),
					onChangeText: _.debounce( searchChanged.bind( this ), 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.COMPANIES ) ? { onPress: createCompany.bind( this ) } : null }
		/>
	);
	
	let content = <LoadingComponent />;
	
	if( !loading ) {
		content = (
			<ManagementGroupedThemeList
				header={ header }
				items={ _managementCompanies }
				renderItem={ renderItem.bind( this ) }
				groupByKey={ 'active' }
				filters={ filters }
				groupByValues={ [
					constantsActive.YES,
					constantsActive.NO
				] }
			/>
		);
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={i18n.t('management:pages.company.companies.title')}
				topNavigation={ true }
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementCompaniesScene
